import { render, staticRenderFns } from "./EmptyTableRow.vue?vue&type=template&id=18c82d93&scoped=true"
import script from "./EmptyTableRow.vue?vue&type=script&lang=js"
export * from "./EmptyTableRow.vue?vue&type=script&lang=js"
import style0 from "./EmptyTableRow.vue?vue&type=style&index=0&id=18c82d93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c82d93",
  null
  
)

export default component.exports